import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useActions } from '../hooks/useActions';
import { useDemoSite } from '../hooks/useDemoSite';

export function PostDemo() {
  const { deleteBudget } = useActions();
  const { createDemoBudget } = useDemoSite();
  const [ params ] = useSearchParams();

  async function removeDemoBudget() {
    await deleteBudget(params.get('budgetId'));
  }

  async function onSignup() {
    await removeDemoBudget();
    window.location.href = 'https://app.goodsteward.io/signup';
  }

  async function onReset() {
    await removeDemoBudget();
    await createDemoBudget();
  }

  useEffect(() => {
    switch (params.get('action')) {
      case 'signup':
        onSignup();
        break;
      case 'reset':
        onReset();
        break;
    }
  }, [params]);
}
